// Mood: its lists that open by address, and the count printed on each list's card. No
// React in here.
//
// Both lists come from ONE answer, the watchlist call:
//   • Low-mood watchlist: unhappy on two or more days. It follows the Month picker. The
//     call note is written on that list.
//   • Not submitted today: no mood logged yet today. It is always today's, whichever
//     month is picked.
import type { DashboardListInfo } from './types';

export const MOOD_LIST = { lowMood: 'low-mood', notSubmitted: 'not-submitted' } as const;

export const LISTS: DashboardListInfo[] = [
  { slug: MOOD_LIST.lowMood, name: 'Low-mood watchlist', line: 'People unhappy on two or more days this month. Add or read a call note against each.', keywords: 'unhappy call note morale' },
  { slug: MOOD_LIST.notSubmitted, name: 'Not submitted today', line: 'People who have not logged a mood yet today.', keywords: 'not logged missing check-in' },
];

/** The part of the watchlist answer the counts are read from. */
export interface WatchlistAnswer {
  lowMood: { total: number; rows: unknown[] };
  notSubmittedToday: { total: number; rows: unknown[] };
}

export interface WatchCounts {
  /** People on the Low-mood watchlist. */
  lowMood: number | null;
  /** People on Not submitted today. */
  notSubmitted: number | null;
}

const NOT_LOADED: WatchCounts = { lowMood: null, notSubmitted: null };

// A list's count is its total only while that is also how many rows the pop-up will show.
// If the two ever part (an answer that sends fewer rows than it counted), the count is
// withheld rather than printed beside a list that does not add up to it.
const listCount = (list: { total: number; rows: unknown[] } | undefined): number | null =>
  list && Array.isArray(list.rows) && list.total === list.rows.length ? list.total : null;

/**
 * The counts, read from the watchlist answer. Pass null while it is on its way or after
 * it failed: every count is then null, which is "not known", never zero.
 */
export function readWatchCounts(answer: WatchlistAnswer | null): WatchCounts {
  if (!answer) return NOT_LOADED;
  return {
    lowMood: listCount(answer.lowMood),
    notSubmitted: listCount(answer.notSubmittedToday),
  };
}
